module.exports = __webpack_public_path__ + "static/Repeat Grid 2-a87216002f022dbd3bcef4fc73e339c0.svg";